import { uuid, varchar, timestamp } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { commonFields } from './common-fields';
import { companies } from './companies';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { CompanyUserRole } from './company-users';
import { users } from './users';

export type CompanyInviteRequest = InferSelectModel<typeof companyInviteRequests>;

export const companyInviteRequests = pgTable('company_invite_requests', {
  ...commonFields,
  acceptedAt: timestamp(),
  rejectedAt: timestamp(),
  role: varchar().notNull().$type<CompanyUserRole>().notNull(),
  companyId: uuid()
    .references(() => companies.id)
    .notNull(),
  userId: uuid()
    .references(() => users.id)
    .notNull(),
});

export const companyInviteRequestsRelations = relations(companyInviteRequests, ({ one }) => ({
  company: one(companies, {
    fields: [companyInviteRequests.companyId],
    references: [companies.id],
  }),
  user: one(users, {
    fields: [companyInviteRequests.userId],
    references: [users.id],
  }),
}));
